import { Theme, Components } from '@mui/material/styles';

export const components: Components<Theme> = {
    MuiCssBaseline: {
        styleOverrides: {
            body: {
                backgroundColor: '#F5F5F2',
            },
            '::selection': {
                backgroundColor: '#7C8CFF',
                color: '#111111',
            },
        },
    },
    MuiButton: {
        styleOverrides: {
            root: {
                textTransform: "none",
                borderRadius: "999px",
                padding: "0.85em 1.8em",
                fontWeight: 500,
                border: "1px solid transparent",
                boxShadow: "none",
            },
        },
        variants: [
            {
                props: { variant: 'contained' },
                style: ({ theme }: { theme: Theme }) => ({
                    backgroundColor: theme.palette.navy.main,
                    color: theme.palette.navy.contrastText,
                    '&:hover': {
                        backgroundColor: theme.palette.navy.light,
                        boxShadow: "none",
                    },
                }),
            },
            {
                props: { variant: 'outlined' },
                style: ({ theme }: { theme: Theme }) => ({
                    backgroundColor: 'transparent',
                    borderColor: theme.palette.divider,
                    color: theme.palette.text.primary,
                    '&:hover': {
                        borderColor: theme.palette.text.primary,
                        backgroundColor: 'transparent',
                    },
                }),
            },
            {
                props: { variant: 'text' },
                style: ({ theme }: { theme: Theme }) => ({
                    padding: "0.4em 0",
                    borderRadius: 0,
                    color: theme.palette.text.primary,
                    '&:hover': {
                        backgroundColor: 'transparent',
                        color: theme.palette.primary.main,
                    },
                }),
            },
        ],
    },
    MuiContainer: {
        styleOverrides: {
            root: {
                maxWidth: '1400px !important',
            },
        },
    },
};
